import { SearchCriteriaLabels } from "src/app/core/models/company.model";

export function getDepartmentsLabel(value: string): string {
    return SearchCriteriaLabels[value] || '';
}